import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import { fadeIn } from "../../utils/motion";
import SectionHeading from "../common/SectionHeading";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setActiveSection } from "../../reducers/slices/navSlice";
import { SocialMediaLinks } from "../../data/SocialMediaLinks";

const SocialMedia = () => {
    const dispatch = useDispatch();
    const { ref, inView } = useInView({
      threshold: 0.75,
    });
  
    const { timeOfLastClick } = useSelector((state) => state.activeSec);
  
    useEffect(() => {
      if (inView && Date.now() - timeOfLastClick > 1000) {
        dispatch(setActiveSection("socialmedia"));
      }
    }, [inView]);

  return (
    <section
    ref={ref}
    className="relative z-10 w-full flex flex-col scroll-m-20 gap-16 min-h-[600px] mt-12 pt-20 transition-colors duration-500"
    id="socialmedia"
    >
    <SectionHeading text="Social Media" />
    <div className="w-[95%] max-w-[1260px] mx-auto mt-16 py-24">
        <ul className="w-full max-w-[53rem] flex mx-auto flex-wrap justify-center gap-2">
        <div className="flex flex-wrap gap-10 justify-center">
            {SocialMediaLinks.map((social, index) => (
            <div
                key={index}
                className="flex flex-col gap-3"
            >
                <div className="flex w-24 h-24 rounded-full bg-white dark:bg-white/10 shadow-slate-300 dark:shadow-[0_16px_18px_-10px_rgba(0,0,0,0.5)] shadow-[0_16px_18px_-10px_rgba(0,0,0,0.1)] justify-center items-center hover:scale-110 ease-in duration-200">
                <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                    src={social.imgSrc}
                    alt={`${social.name} logo`}
                    style={{ width: "80px", height: "80px" }}
                    />
                </a>
                </div>

                <div className="text-gray-800 dark:text-white mt-5">
                <a
                    href={social.url}
                    className="flex gap-2 items-center cursor-pointer hover:text-accent-primary transition-colors"
                >
                    <FaExternalLinkAlt className="flex-shrink-0" />
                    <p className="font-medium text-lg min-w-[68px] cursor-pointer">
                    {social.name}
                    </p>
                </a>
                </div>
            </div>
            ))}
        </div>
        </ul>
    </div>
    </section>
  );
};

export default SocialMedia;
